import { useState } from 'react';
import { faqData } from '@/mocks/data';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />

        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            关于芒果视频，你想知道的都在这里
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {item.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 flex-shrink-0 ${
                  openIndex === index ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}